// extracted by mini-css-extract-plugin
export default {"dropdownItem":"DropdownMenu_dropdownItem__H6r+x"};